import React from 'react';
export const VipModuleSection = () => {
  const levels = [{
    title: 'Nivel 1 — Inicial (Verde)',
    color: 'text-familia-green',
    items: ['Para movilidad muy reducida o deterioro cognitivo', 'Ejercicios 100% en silla o cama', 'Actividades de reconocimiento y estimulación básica', '50 actividades físicas y cognitivas']
  }, {
    title: 'Nivel 2 — Medio (Azul)',
    color: 'text-blue-400',
    items: ['Para adultos activos con apoyo o supervisión', 'Ejercicios de fuerza y equilibrio con apoyo', 'Actividades de lógica y cálculo cotidiano', '50 actividades físicas y cognitivas']
  }, {
    title: 'Nivel 3 — Avanzado (Púrpura)',
    color: 'text-purple-400',
    items: ['Para adultos mayores independientes y activos', 'Ejercicios de coordinación y resistencia', 'Actividades de abstracción y desafío mental', '50 actividades físicas y cognitivas']
  }];
  return <section id="vip" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-288">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-289">
        <div className="text-center mb-10 md:mb-16" data-id="element-290">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-291">
            ⚡ MÁS EL MÓDULO MAESTRO EXCLUSIVO
          </h2>
          <p className="text-familia-cyan font-bold text-lg md:text-xl mb-4" data-id="element-292">
            MÓDULO VIP — Ejercicios prácticos en casa 150+
          </p>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-293">
            El corazón del Master Kit. +150 actividades físicas y cognitivas
            organizadas en 3 niveles de adaptación según el estado real del
            adulto mayor. Nunca más te vas a quedar sin saber qué hacer. Nunca
            más vas a improvisar.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-294">
          {levels.map((level, i) => <div key={i} className="bg-familia-card border border-white/5 p-6 md:p-8 rounded-2xl" data-id="element-295">
              <h3 className={`text-lg md:text-xl font-bold mb-6 ${level.color}`} data-id="element-296">
                {level.title}
              </h3>
              <ul className="space-y-4" data-id="element-297">
                {level.items.map((item, j) => <li key={j} className="flex items-start gap-3 text-sm md:text-base text-white/90" data-id="element-298">
                    <span className={`${level.color} shrink-0`} data-id="element-299">→</span>
                    <span data-id="element-300">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};